/**
 * Page manager placement for live access
 */
export const PM_PLACEMENT_PAYLOAD_TYPE_SPOTLIGHT_LIVE_ACCESS = 'live-access-spotlight'
/**
 * Page manager placement for featured content impression
 */
export const PM_PLACEMENT_PAYLOAD_TYPE_FEATURED_CONTENT_IMPRESSION = 'featured-content-impression'
/**
 * Page manager placement for featured content impression
 */
export const PM_PLACEMENT_PAYLOAD_TYPE_PINE_TOP_VIDEO = 'pine-top-video'
/**
 * Page manager placement for merchandising content
 */
export const PM_PLACEMENT_PAYLOAD_TYPE_MERCHANDISING_CONTENT = 'merchandising-content'
